/**
 * RGM Judging · Phase 2 — Reusable A&R Recommendation Picker.
 *
 * Presentational-only 3-button pill row (Yes / Maybe / No). Parent
 * owns state + persistence. Reused by:
 *   • Phase 2 Spotlight A&R Workspace
 *   • Phase 3 A&R Listening Room (embed unchanged)
 */
import React from "react";

const OPTIONS = [
  { value: "yes",   label: "YES",   glyph: "✅", tone: "emerald" },
  { value: "maybe", label: "MAYBE", glyph: "🤔", tone: "amber" },
  { value: "no",    label: "NO",    glyph: "❌", tone: "rose" },
];

const _tone = (t, on) => {
  if (t === "emerald") return on ? "border-emerald-400/70 bg-emerald-500/20 text-emerald-100" : "border-white/15 text-gray-400 hover:border-emerald-400/40";
  if (t === "amber")   return on ? "border-amber-400/70 bg-amber-500/20 text-amber-100"     : "border-white/15 text-gray-400 hover:border-amber-400/40";
  return on ? "border-rose-400/70 bg-rose-500/20 text-rose-100" : "border-white/15 text-gray-400 hover:border-rose-400/40";
};

export default function RecommendationPicker({ value = null, disabled = false, onChange }) {
  return (
    <div className="flex items-center gap-2" role="radiogroup" aria-label="A&R recommendation" data-testid="ar-recommendation-picker">
      {OPTIONS.map((o) => {
        const on = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={on}
            disabled={disabled}
            onClick={() => onChange?.(on ? null : o.value)}
            className={`flex-1 h-9 rounded border text-xs font-bold tabular-nums transition disabled:opacity-40 ${_tone(o.tone, on)}`}
            data-testid={`ar-recommendation-${o.value}`}
          >
            <span aria-hidden="true" className="mr-1">{o.glyph}</span>{o.label}
          </button>
        );
      })}
    </div>
  );
}
